import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const RevenueChart = ({ data, loading }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-semibold text-foreground mb-1">{payload?.[0]?.payload?.month}</p>
          <p className="text-xs text-success">
            {payload?.[0]?.value > 0
              ? `Pipeline: $${payload?.[0]?.value?.toLocaleString()}`
              : 'No projects this month'}
          </p>
        </div>
      );
    }
    return null;
  };

  const hasData = data?.some(d => d?.revenue > 0);

  return (
    <div className="bg-card border border-border rounded-xl p-4 sm:p-5 md:p-6">
      <div className="flex items-center justify-between mb-4 sm:mb-6">
        <h3 className="text-base sm:text-lg font-semibold text-foreground">Pipeline by Month</h3>
        <span className="text-xs sm:text-sm text-muted-foreground">Last 6 months</span>
      </div>
      {loading ? (
        <div className="w-full h-56 sm:h-64 flex items-center justify-center">
          <div className="animate-pulse space-y-2 w-full">
            <div className="flex items-end gap-2 h-40 px-4">
              {[60, 80, 50, 90, 70, 85]?.map((h, i) => (
                <div key={i} className="flex-1 bg-muted rounded-t" style={{ height: `${h}%` }} />
              ))}
            </div>
            <div className="h-3 bg-muted rounded w-full" />
          </div>
        </div>
      ) : !hasData ? (
        <div className="w-full h-56 sm:h-64 flex flex-col items-center justify-center text-center">
          <Icon name="BarChart2" size={40} className="text-muted-foreground mb-3" />
          <p className="text-sm font-medium text-muted-foreground">No project data yet</p>
          <p className="text-xs text-muted-foreground mt-1">Pipeline value will appear here as projects are added</p>
        </div>
      ) : (
        <div className="w-full h-56 sm:h-64 md:h-80 overflow-x-auto" aria-label="Pipeline Revenue Bar Chart">
          <ResponsiveContainer width="100%" height="100%" minWidth={300}>
            <BarChart data={data} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
              <XAxis
                dataKey="month"
                tick={{ fill: 'var(--color-muted-foreground)', fontSize: 11 }}
                axisLine={{ stroke: 'var(--color-border)' }}
              />
              <YAxis
                tick={{ fill: 'var(--color-muted-foreground)', fontSize: 11 }}
                axisLine={{ stroke: 'var(--color-border)' }}
                tickFormatter={(value) => value >= 1000 ? `$${value / 1000}k` : `$${value}`}
              />
              <Tooltip content={<CustomTooltip />} />
              <Bar
                dataKey="revenue"
                fill="#1B3A5C"
                radius={[8, 8, 0, 0]}
                name="Pipeline Value"
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default RevenueChart;